module.exports = __webpack_public_path__ + "img/rank-on.85cf4c7b.png";